import React from "react"
import { useTranslation } from "react-i18next"

import { PopupWrapper } from "~/components/Popup/Popup"
import { Raw } from "~/components/raw"
import { ShadowField } from "~/components/ShadowField/ShadowField"

import { Content } from "./components/Content/Content"
import styles from "./index.module.css"

type Props = {
  categoriesList: { id: string; code: string; name: string }[]
  state: string[]
  onChange: (v: string[]) => void
  returnValuesType: "id" | "code" | "name"
}

export const PopupCategories: React.FC<Props> = ({
  categoriesList,
  state,
  onChange,
  returnValuesType,
}) => {
  const { t } = useTranslation()
  const count = state?.length || ""

  return (
    <PopupWrapper
      button={
        <ShadowField icon="plus">
          <Raw html={t("PopupCategories.Select")} />

          {count && <span className={styles.Count}>{count}</span>}
        </ShadowField>
      }
      content={({ closeHandler }) => (
        <Content
          categoriesList={categoriesList}
          closeHandler={closeHandler}
          returnValuesType={returnValuesType}
          state={state}
          onSubmit={onChange}
        />
      )}
    />
  )
}
